export default __webpack_public_path__ + "static/spark-of-ages-c055afd88b3f23dfc4f4b56c6718426c.png";